<script>
    export default {
        props: {
            placeholder: null,
        },
        data() {
            return {
                options: [],
                selected: null,
            }
        },
        watch: {
            selected(value) {
                this.onChange(value);
            },
        },
        methods: {
            onSearch(search, loading) {
                loading(true);
                this.search(loading, search, this);
            },
            onChange(option) {
                window.location.href = option.url;
            },
            search: _.debounce((loading, search, vm) => {
                axios.get(`${Scoop.baseUrl}/api/search/${encodeURIComponent(search)}`).then(res => {
                    vm.options = res.data.items;
                    loading(false);
                });
            }, 400)
        }
    }
</script>

<template>
    <div class="global-search-bar navbar-form-custom">
        <v-select
                :options="options"
                @search="onSearch"
                v-model="selected"
                :placeholder="placeholder"
                :filterable="false"
        ></v-select>
    </div>
</template>
